/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';

import ShortenedShippingABTest from './ShortenedShippingABTest';
import OnePageCheckoutABTest from './OnePageCheckoutABTest';
import MiddlePlaceOrderButtonABTest from './MiddlePlaceOrderButtonABTest';
import RememberMeABTest from './RememberMeABTest';
import CalendarMessageABTest from './CalendarMessageABTest';
import ModalQasRadioButtonsABTest from './ModalQasRadioButtonsABTest';
import CheckUnverifiedAddressesABTest from './CheckUnverifiedAddressesABTest';
import DeliveryDateSelectionsABTest from './DeliveryDateSelectionsABTest';
import LongerPassportMessageABTest from './LongerPassportMessageABTest';
import EnterpriseCalendarABTest from './EnterpriseCalendarABTest';
import NewProductSFAbTest from './NewProductSFAbTest';
import CardisleGridViewABTest from './CardisleGridViewABTest';
import OrderSummaryRemappingABTest from './OrderSummaryRemappingABTest';

const ABTestSalesForceBuilder = ({ featureFlags, pageType }) => (
    <>
        {
            featureFlags['is-hidden-extended-address-info-enabled'] === 'saleforce'
            && <ShortenedShippingABTest pageType={pageType} />
        }
        {
            featureFlags['is-one-page-checkout-enabled'] === 'salesforce'
            && <OnePageCheckoutABTest pageType={pageType} />
        }
        {
            featureFlags['is-middle-place-order-hidden-enabled'] === 'salesforce'
            && <MiddlePlaceOrderButtonABTest pageType={pageType} />
        }
        {
            featureFlags['is-checkout-oneclick-account-creation-enabled'] === 'salesforce'
            && <RememberMeABTest pageType={pageType} />
        }
        {
            featureFlags['is-cal-messaging-ab-test-enabled'] === true
            && <CalendarMessageABTest pageType={pageType} />
        }
        {
            featureFlags['is-qas-modal-with-radio-buttons-enabled'] === 'salesforce'
            && <ModalQasRadioButtonsABTest pageType={pageType} />
        }
        {
            featureFlags['is-check-unverified-addresses-enabled'] === 'salesforce'
            && <CheckUnverifiedAddressesABTest pageType={pageType} />
        }
        {
            featureFlags['is-delivery-date-selections-enabled'] === 'salesforce'
            && <DeliveryDateSelectionsABTest pageType={pageType} featureFlags={featureFlags} />
        }
        {
            featureFlags['is-longer-passport-message-enabled'] === 'salesforce'
            && <LongerPassportMessageABTest pageType={pageType} />
        }
        {
            featureFlags['is-enterprise-calendar-enabled'] === 'salesforce'
            && <EnterpriseCalendarABTest pageType={pageType} />
        }
        {  featureFlags['is-new-product-card-enabled'] && <NewProductSFAbTest />}

        {
            featureFlags['is-card-isle-grid-view-enabled-in-checkout'] === 'salesforce'
            && <CardisleGridViewABTest pageType={pageType} />
        }
        {
            featureFlags['is-order-summary-remapping-enabled'] === 'salesforce'
            && <OrderSummaryRemappingABTest pageType={pageType} />
        }
    </>
);

ABTestSalesForceBuilder.propTypes = {
    featureFlags: object.isRequired,
    pageType: string.isRequired,
};

export default ABTestSalesForceBuilder;
